module.exports = __webpack_public_path__ + "img/agentCheck1.cff0e4b1.png";